// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tCPBzWZOv9jg9RofGOah {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  max-width: 132px;
  aspect-ratio: var(--game-card-aspect-ratio);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 0 20px 0 #fff41a;
  background: #111;
  cursor: pointer;
}
/* Mirrors the regular game-card formula in Game.module.css so featured stays the same size as siblings on phones. */
@media (max-width: 500px) and (min-width: 375px) {
  .tCPBzWZOv9jg9RofGOah {
    max-width: 34.2vw;
  }
}
@media (min-width: 501px) {
  .tCPBzWZOv9jg9RofGOah {
    max-width: 164px;
  }
}
@media (min-width: 1026px) {
  .tCPBzWZOv9jg9RofGOah {
    max-width: 246px;
  }
}
.tCPBzWZOv9jg9RofGOah[data-loading] {
  cursor: wait;
}
/* Single-view list: the card fills its grid column (like a regular game card,
   which drops its max-width via [data-view='single'] in Game.module.css) so the
   arrangement matches the other single-view sections. */
.tCPBzWZOv9jg9RofGOah[data-view='single'] {
  max-width: 100%;
}
/* Single-view list: every card except the first ('plain') drops the yellow
   glow and renders its amount in white instead of hero-yellow. The hero-yellow
   default lives on .footer (--tw-amount-color) further down. */
.tCPBzWZOv9jg9RofGOah[data-variant='plain'] {
  box-shadow: none;
}
.tCPBzWZOv9jg9RofGOah[data-variant='plain'] .MZ3fP4z0_TUhCpzt2zA2 {
  --tw-amount-color: #fff;
}
.YZe3Adu0i8D4eHn_uxWj {
  display: none;
}
@media (hover: hover) and (pointer: fine) {
  .tCPBzWZOv9jg9RofGOah:hover .MZ3fP4z0_TUhCpzt2zA2 {
    visibility: hidden;
  }
  .tCPBzWZOv9jg9RofGOah:hover .YZe3Adu0i8D4eHn_uxWj {
    display: flex;
  }
  .tCPBzWZOv9jg9RofGOah:hover::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.75);
    border-radius: inherit;
    z-index: 1;
    pointer-events: none;
  }
}
@media (hover: none) and (pointer: coarse) {
  .tCPBzWZOv9jg9RofGOah:hover .MZ3fP4z0_TUhCpzt2zA2 {
    visibility: visible !important;
  }
  .tCPBzWZOv9jg9RofGOah:hover .YZe3Adu0i8D4eHn_uxWj {
    display: none !important;
  }
  .tCPBzWZOv9jg9RofGOah:hover::before {
    display: none !important;
  }
}
.XkF3_Af_Tdp4VTQFDFTq {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 15%;
  display: block;
}
.N9y3wHBJDMq65dBqHP5l {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 54%, rgba(0, 0, 0, 0.4) 77%, rgba(0, 0, 0, 0.64) 92%);
}
/* Jackpot badge plate — matches the same 40% top-left placement Game.tsx uses
   for regular game cards. Top-left corner radius matches the card's. No
   z-index: relies on DOM order so the TagsContainer (rendered right after)
   paints the badge icon on top of this plate. */
.DjvsYmy_Cq0lLBXWNMTQ {
  position: absolute;
  top: 0;
  left: 0;
  width: var(--badge-plate-width, 40%);
  height: auto;
  min-height: 1px;
  border-radius: 14px 0 0 0;
  pointer-events: none;
}
@media (max-width: 1279px) {
  .DjvsYmy_Cq0lLBXWNMTQ {
    border-radius: 10px 0 0 0;
  }
}
.iF6OGTQzuePpcCs4t1VY {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 21px;
  height: 21px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.6));
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  /* Prevent iOS flickering */
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
}
/* Extended touch target for smaller screens */
.iF6OGTQzuePpcCs4t1VY::after {
  content: '';
  position: absolute;
  inset-block: -7px;
  inset-inline: -7px;
}
/* fallow-ignore-next-line unused-export */
.hQq8wQi7U1Jj0z6GRI9Q {
  width: 21px;
  height: 21px;
}
/* Matches regular game-card favorite-button breakpoint (1025+):
   button 32×32 with a 28×28 svg inside — same as GameComponents.module.css. */
@media (min-width: 1025px) {
  .iF6OGTQzuePpcCs4t1VY {
    width: 32px;
    height: 32px;
  }
  .hQq8wQi7U1Jj0z6GRI9Q {
    width: 28px;
    height: 28px;
  }
}
.MZ3fP4z0_TUhCpzt2zA2 {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  /* Theme the shared <TopWinAmount> (see TopWinAmount.module.css): the hero
     yellow, centered, 30px. */
  --tw-amount-clip: 30px;
  --tw-amount-size: 30px;
  --tw-amount-color: #fff41a;
  --tw-amount-justify: center;
  --tw-amount-origin: center center;
  /* Breathing margin so a scaled-to-fit amount doesn't touch the card edges. */
  --tw-amount-inset: 12px;
}
.fjZP5GpO8dvYnnfbqZsh {
  font-family: var(--font-family-primary);
  font-style: italic;
  font-size: 18px;
  color: #fff;
  line-height: 0.5;
}
/* Compact featured (≤1025px) — aligns with the game-card breakpoint where
   regular cards switch from 246px (desktop) down to 164px (tablet). */
@media (max-width: 1025px) {
  .tCPBzWZOv9jg9RofGOah {
    border-radius: 10px;
    box-shadow: 0 0 13.6px 0 #fff41a;
  }
  .MZ3fP4z0_TUhCpzt2zA2 {
    bottom: 10px;
    gap: 4px;
    height: 30px;
    /* Compact amount: 20px. */
    --tw-amount-clip: 20px;
    --tw-amount-size: 20px;
  }
  .fjZP5GpO8dvYnnfbqZsh {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/topWins/components/TopWinFeaturedCard/TopWinFeaturedCard.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;AACA,oHAAoH;AACpH;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,YAAY;AACd;AACA;;wDAEwD;AACxD;EACE,eAAe;AACjB;AACA;;+DAE+D;AAC/D;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,sBAAsB;IACtB,UAAU;IACV,oBAAoB;EACtB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,6GAA6G;AAC/G;AACA;;;gDAGgD;AAChD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,gCAAgC;AAClC;AACA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;AACd;AACA;8EAC8E;AAC9E;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB;8BAC4B;EAC5B,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,6EAA6E;EAC7E,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;sEACsE;AACtE;EACE;IACE,mBAAmB;IACnB,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".card {\n  position: relative;\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 132px;\n  aspect-ratio: var(--game-card-aspect-ratio);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 0 20px 0 #fff41a;\n  background: #111;\n  cursor: pointer;\n}\n/* Mirrors the regular game-card formula in Game.module.css so featured stays the same size as siblings on phones. */\n@media (max-width: 500px) and (min-width: 375px) {\n  .card {\n    max-width: 34.2vw;\n  }\n}\n@media (min-width: 501px) {\n  .card {\n    max-width: 164px;\n  }\n}\n@media (min-width: 1026px) {\n  .card {\n    max-width: 246px;\n  }\n}\n.card[data-loading] {\n  cursor: wait;\n}\n/* Single-view list: the card fills its grid column (like a regular game card,\n   which drops its max-width via [data-view='single'] in Game.module.css) so the\n   arrangement matches the other single-view sections. */\n.card[data-view='single'] {\n  max-width: 100%;\n}\n/* Single-view list: every card except the first ('plain') drops the yellow\n   glow and renders its amount in white instead of hero-yellow. The hero-yellow\n   default lives on .footer (--tw-amount-color) further down. */\n.card[data-variant='plain'] {\n  box-shadow: none;\n}\n.card[data-variant='plain'] .footer {\n  --tw-amount-color: #fff;\n}\n.playButton {\n  display: none;\n}\n@media (hover: hover) and (pointer: fine) {\n  .card:hover .footer {\n    visibility: hidden;\n  }\n  .card:hover .playButton {\n    display: flex;\n  }\n  .card:hover::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.75);\n    border-radius: inherit;\n    z-index: 1;\n    pointer-events: none;\n  }\n}\n@media (hover: none) and (pointer: coarse) {\n  .card:hover .footer {\n    visibility: visible !important;\n  }\n  .card:hover .playButton {\n    display: none !important;\n  }\n  .card:hover::before {\n    display: none !important;\n  }\n}\n.thumbnail {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 15%;\n  display: block;\n}\n.overlay {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 54%, rgba(0, 0, 0, 0.4) 77%, rgba(0, 0, 0, 0.64) 92%);\n}\n/* Jackpot badge plate — matches the same 40% top-left placement Game.tsx uses\n   for regular game cards. Top-left corner radius matches the card's. No\n   z-index: relies on DOM order so the TagsContainer (rendered right after)\n   paints the badge icon on top of this plate. */\n.badgePlate {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--badge-plate-width, 40%);\n  height: auto;\n  min-height: 1px;\n  border-radius: 14px 0 0 0;\n  pointer-events: none;\n}\n@media (max-width: 1279px) {\n  .badgePlate {\n    border-radius: 10px 0 0 0;\n  }\n}\n.favoriteButton {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  width: 21px;\n  height: 21px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.6));\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n  /* Prevent iOS flickering */\n  backface-visibility: hidden;\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  -webkit-transform: translateZ(0);\n}\n/* Extended touch target for smaller screens */\n.favoriteButton::after {\n  content: '';\n  position: absolute;\n  inset-block: -7px;\n  inset-inline: -7px;\n}\n/* fallow-ignore-next-line unused-export */\n.favoriteIcon {\n  width: 21px;\n  height: 21px;\n}\n/* Matches regular game-card favorite-button breakpoint (1025+):\n   button 32×32 with a 28×28 svg inside — same as GameComponents.module.css. */\n@media (min-width: 1025px) {\n  .favoriteButton {\n    width: 32px;\n    height: 32px;\n  }\n  .favoriteIcon {\n    width: 28px;\n    height: 28px;\n  }\n}\n.footer {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  text-align: center;\n  /* Theme the shared <TopWinAmount> (see TopWinAmount.module.css): the hero\n     yellow, centered, 30px. */\n  --tw-amount-clip: 30px;\n  --tw-amount-size: 30px;\n  --tw-amount-color: #fff41a;\n  --tw-amount-justify: center;\n  --tw-amount-origin: center center;\n  /* Breathing margin so a scaled-to-fit amount doesn't touch the card edges. */\n  --tw-amount-inset: 12px;\n}\n.timeAgo {\n  font-family: var(--font-family-primary);\n  font-style: italic;\n  font-size: 18px;\n  color: #fff;\n  line-height: 0.5;\n}\n/* Compact featured (≤1025px) — aligns with the game-card breakpoint where\n   regular cards switch from 246px (desktop) down to 164px (tablet). */\n@media (max-width: 1025px) {\n  .card {\n    border-radius: 10px;\n    box-shadow: 0 0 13.6px 0 #fff41a;\n  }\n  .footer {\n    bottom: 10px;\n    gap: 4px;\n    height: 30px;\n    /* Compact amount: 20px. */\n    --tw-amount-clip: 20px;\n    --tw-amount-size: 20px;\n  }\n  .timeAgo {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `tCPBzWZOv9jg9RofGOah`,
	"footer": `MZ3fP4z0_TUhCpzt2zA2`,
	"playButton": `YZe3Adu0i8D4eHn_uxWj`,
	"thumbnail": `XkF3_Af_Tdp4VTQFDFTq`,
	"overlay": `N9y3wHBJDMq65dBqHP5l`,
	"badgePlate": `DjvsYmy_Cq0lLBXWNMTQ`,
	"favoriteButton": `iF6OGTQzuePpcCs4t1VY`,
	"favoriteIcon": `hQq8wQi7U1Jj0z6GRI9Q`,
	"timeAgo": `fjZP5GpO8dvYnnfbqZsh`
};
export default ___CSS_LOADER_EXPORT___;
